import { getModule } from 'vuex-module-decorators';
import ProfileStore from '@/profile/store';
import { store } from '@/store';

const profileStore = getModule(ProfileStore, store);

export const profileMyProfileResolver = async (): Promise<void> => {
	await profileStore.getAndSetAccounts();

	await Promise.all([
		profileStore.setInstitutionsFromAccounts(),
		profileStore.getAndSetLinkedAccounts(),
	]);
};
